import React from 'react'
import { useRouter } from 'next/router'

export type PageParams = {
    companySlug: string
    page: number
}

export const useParams = () => {
    const router = useRouter()
    const page = router.query['page'] as string | undefined
    const companySlug = router.query['slug'] as string

    return React.useMemo(() => {
        return {
            companySlug,
            page: Number(page) || 1,
        }
    }, [page, companySlug])
}
